import { Configuration, LogLevel, PublicClientApplication } from '@azure/msal-browser';

const rc = (window as any).__RUNTIME_CONFIG__ || {};
const clientId = rc.ENTRA_CLIENT_ID || import.meta.env.VITE_ENTRA_CLIENT_ID || '';
const tenantId = rc.ENTRA_TENANT_ID || import.meta.env.VITE_ENTRA_TENANT_ID || '';

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      piiLoggingEnabled: false,
    },
  },
};

export const loginRequest = {
  scopes: [`api://${clientId}/access_as_user`],
};

export const apiScopes = {
  scopes: [`api://${clientId}/access_as_user`],
};

// Shared MSAL singleton — used by main.tsx (MsalProvider) and api.ts (token interceptor)
export const msalInstance = new PublicClientApplication(msalConfig);

// Initialize once, reused everywhere
export const msalReady: Promise<void> = msalInstance.initialize();
